var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 21,
    viewBox: "0 0 30 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.4814 3.31587C28.1579 2.05874 27.2098 1.06776 26.0075 0.729249C23.8111 0.100952 15.0251 0.100952 15.0251 0.100952C15.0251 0.100952 6.23946 0.100952 4.043 0.705428C2.86383 1.04358 1.89263 2.05892 1.56919 3.31587C0.991165 5.61198 0.991165 10.3738 0.991165 10.3738C0.991165 10.3738 0.991165 15.1597 1.56919 17.4318C1.89298 18.6887 2.8407 19.6797 4.04318 20.0182C6.26259 20.6467 15.0254 20.6467 15.0254 20.6467C15.0254 20.6467 23.8111 20.6467 26.0075 20.0422C27.21 19.7039 28.1579 18.7129 28.4817 17.456C29.0596 15.1597 29.0596 10.398 29.0596 10.398C29.0596 10.398 29.0827 5.61198 28.4814 3.31587ZM12.2278 14.773V5.97467L19.5338 10.3738L12.2278 14.773Z",
    fill: "#9876CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconYoutube);
export default __webpack_public_path__ + "static/media/iconYoutube.04c4815ac60193f3307c42ace9259ad0.svg";
export { ForwardRef as ReactComponent };